import { Quote, Star } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { STATS, TESTIMONIALS } from "@/data/site";

export function TrustSection() {
  return (
    <section data-testid="trust-section" className="bg-warm text-navy py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 border-y border-navy/10 py-12">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08}>
              <div className="text-center md:text-left">
                <p className="font-playfair text-5xl md:text-6xl text-gradient-gold">{s.value}</p>
                <p className="text-navy/50 text-sm mt-2 tracking-wide">{s.label}</p>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Testimonials */}
        <div className="mt-24 text-center max-w-2xl mx-auto">
          <p className="accent-eyebrow text-terracotta">Journeys we've guided</p>
          <h2 className="font-playfair text-4xl md:text-5xl mt-5 leading-tight">People trust people.</h2>
          <p className="text-navy/55 mt-5 text-lg">Real families, founders and dreamers who built their future in Portugal with us beside them.</p>
        </div>

        <div className="mt-16 grid gap-6 md:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.1}>
              <div className="h-full rounded-3xl bg-white border border-navy/10 p-8 flex flex-col shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-500">
                <Quote className="h-8 w-8 text-gold" />
                <div className="flex gap-0.5 mt-4">
                  {Array.from({ length: 5 }).map((_, s) => <Star key={s} className="h-4 w-4 fill-gold text-gold" />)}
                </div>
                <p className="text-navy/75 mt-5 leading-relaxed flex-1">"{t.quote}"</p>
                <div className="mt-7 flex items-center gap-3 pt-6 border-t border-navy/10">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-navy text-gold font-600 text-sm">{t.initials}</span>
                  <div>
                    <p className="font-600 text-navy text-sm">{t.name}</p>
                    <p className="text-navy/45 text-xs">{t.role}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
